stripePayInvoice.$inject = ["API_URL", "$rootScope", "$http", "$filter", "$location", "$timeout"];
angular.module('directive.stripepayinvoice', []).directive('stripePayInvoice', stripePayInvoice); // Update customer payment method.
// 1. The customer may simply want to update their payment card - not necessarily pay an invoice
// 2. They may need to complete SCA for an invoice.
//      - Immediately pay invoice
// 3. They may need to enter a new card to complete a failed payment.
//      - Immediately pay invoice

function stripePayInvoice(API_URL, $rootScope, $http, $filter, $location, $timeout) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/stripe-pay-invoice.html',
    scope: {
      invoiceToPay: '='
    },
    link: function link(scope, elem, attrs) {
      var stripeCard = null;
      var stripe = window.Stripe(smooth.stripePublicKey),
          elements = stripe.elements();

      scope.submitCard = function () {
        // What happens next depends on the payment intent.
        if (!scope.invoiceToPay) {
          return $rootScope.showError('Sorry but an error has occurred: invoice not found');
        } // invoiceToPay has come from the api


        if (scope.invoiceToPay.intent_next_action && scope.invoiceToPay.intent_next_action === 'use_stripe_sdk') {
          return handleSCA(scope.invoiceToPay.intent_client_secret);
        }

        $rootScope.throbber.show();
        scope.processing = true; // Some payment methods and cards may require further authentication. In all cases
        // retrieve a payment intent from the server. If the transaction requires no further authentication
        // send back the payment intent ID to confirm the transaction.

        stripe.createToken(stripeCard).then(function (result) {
          if (result.error) {
            scope.processing = false;
            $rootScope.throbber.hide();
            scope.stripeError = result.error.message;
            return $rootScope.safeApply();
          }

          payInvoice(result.token, scope.invoiceToPay.stripeinvoiceid);
        });
      };

      var payInvoice = function payInvoice(stripetoken, invoiceid) {
        scope.processing = true;
        $http.put(API_URL + "/api/v1/calendar/membership/payments/update-card/".concat(invoiceid), {
          stripetoken: stripetoken
        }).then(function (reply) {
          $rootScope.throbber.hide();
          scope.processing = false;
          var response = reply.data;

          if (!response.success) {
            scope.stripeError = "Sorry but an error occurred: ".concat(response.msg);
            $rootScope.safeApply();
            $timeout(function () {
              scope.stripeError = '';
            }, 3000);
            return;
          }

          if (response.success && !response.requires_action) {
            scope.stripeSuccess = 'Thanks for your payment. You have successfully paid your invoice, your membership is active ' + 'and you will receive confirmation of your payment by email' + ' Please click the \'ok\' button to be re-directed back to the booking calendar';
            $rootScope.safeApply();
            return;
          } // Do SCA. This is completed client side.


          if (response.requires_action) {
            return handleSCA(response.payment_intent_client_secret);
          }

          scope.stripeError = "Sorry but an error occurred - unhandled status: ".concat(response.status);
          $timeout(function () {
            scope.stripeError = '';
          }, 3000);
        }).catch(function (error) {
          console.error(error.message);
          scope.stripeError = "Sorry but an error occurred - unhandled status: ".concat(error.message);
          scope.processing = false;
          $timeout(function () {
            scope.stripeError = '';
          }, 3000);
        });
      };

      var handleSCA = function handleSCA(clientSecret) {
        $rootScope.throbber.show();
        scope.processing = true; // Handle SCA client side. Success here means a subscription.updated
        // event will be sent to the backend (because the invoice has changed).

        stripe.handleCardPayment(clientSecret, stripeCard).then(function (response) {
          scope.processing = false;
          $rootScope.throbber.hide();

          if (response.error) {
            scope.stripeError = "".concat(response.error.message);
            $timeout(function () {
              scope.stripeError = '';
            }, 3000);
            $rootScope.safeApply();
            return;
          }

          scope.stripeSuccess = 'You have successfully verified your payment card and paid your invoice - your membership will remain active. ' + +'You will receive confirmation of your payment by email' + ' Please click the \'ok\' button to be re-directed back to the booking calendar';
          $rootScope.safeApply();
          $timeout(function () {
            scope.stripeSuccess = '';
            $location.path('/');
          }, 3000);
        }).catch(function (err) {
          console.error(err);
          scope.processing = false;
          scope.stripeError = 'Sorry but an error occurred:' + err.msg;
          $timeout(function () {
            scope.stripeError = '';
          }, 3000);
        });
      };

      scope.cancelPayment = function () {
        var cancelMessage = $filter('calendarLabel')('This will remove your reserved appointments. Continue?');

        if (!confirm(cancelMessage)) {
          return;
        }

        $location.path('/');
      };

      scope.backToHome = function () {
        $location.path('/');
      };

      scope.$watch('invoiceToPay', function () {
        if (scope.invoiceToPay) {
          init();
        }
      });

      var init = function init() {
        stripeCard = elements.create('card');
        stripeCard.mount('#update-payment-card-element');
        stripeCard.addEventListener('change', function (event) {
          var displayError = document.getElementById('card-errors');

          if (event.error) {
            scope.stripeError = event.error.message;
          } else {
            scope.stripeError = '';
          }

          $rootScope.safeApply();
        });
      };
    }
  };
}